import { useLazyQuery } from '@apollo/client/react';
import { QUERY_USER_DETAILS_SHORT_HOST_MSG_BY_ID } from '../../graphql/user-queries';

export default function useUserDetailsShort() {
    const [getUserDetailsShort, { data, loading, error }] = useLazyQuery(QUERY_USER_DETAILS_SHORT_HOST_MSG_BY_ID);

    return { getUserDetailsShort, userDetails: data && data.user, loading, error };
}
